
import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import RealEstate from '../pages/real-estate/page';
import Ships from '../pages/ships/page';
import Cars from '../pages/cars/page';
import Auth from '../pages/auth/page';
import AddListing from '../pages/add-listing/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/real-estate',
    element: <RealEstate />,
  },
  {
    path: '/ships',
    element: <Ships />,
  },
  {
    path: '/cars',
    element: <Cars />,
  },
  {
    path: '/auth',
    element: <Auth />,
  },
  {
    path: '/add-listing',
    element: <AddListing />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
